<template>
    <el-drawer :modal="false" 
        :visible.sync="drawerViewHubSummary"
        class="drawer-hub-summary"
        size="45%"
    >
        <div slot="title" class="d-flex align-items-center" v-if="current_hub">
            <span>{{ current_hub.hub_name }} Performance</span>
        </div>
        <b-container>
            <b-card no-body>
                <div id="chart">
                    <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
                </div>
            </b-card>
            
            <b-tabs pills>
                <template #tabs-start>
                    <h3 class="mr-md-5 mb-md-0 align-self-end d-none d-md-block">Total {{ currentTab }} Cases</h3>
                </template>
                <b-tab title="Pending" active @click="selectTab('Pending')" v-if="current_hub || current_team">
                    <!-- <h3 class="mt-2 d-md-none" v-if="current_hub.total_cases">Total {{ current_hub.total_cases.pending }} Pending Cases</h3> -->
                    <HubSummaryPendingCases :hub_id="hub_id" :hub_team_id="hub_team_id" :revenue_distribution_settings="revenue_distribution_settings" />
                </b-tab>
                <b-tab title="Completed" @click="selectTab('Completed')" v-if="current_hub || current_team">
                    <!-- <h3 class="mt-2 d-md-none" v-if="current_hub.total_cases">Total {{ current_hub.total_cases.actual }} Completed Cases</h3> -->
                    <HubSummaryActualCases :hub_id="hub_id" :hub_team_id="hub_team_id" :revenue_distribution_settings="revenue_distribution_settings" />
                </b-tab>
            </b-tabs>
        </b-container>
    </el-drawer>
</template>
<script>
import { Drawer } from 'element-ui'
import VueApexCharts from 'vue-apexcharts'
import { mapState, mapActions } from 'pinia'
import { useHubStore } from '@/stores/hubStore'
import HubSummaryPendingCases from '@/views/Commission/Hub/HubProfile/OffCanvasDetails/HubSummary/HubSummaryPendingCases'
import HubSummaryActualCases from '@/views/Commission/Hub/HubProfile/OffCanvasDetails/HubSummary/HubSummaryActualCases'


export default {
    components: {
        HubSummaryPendingCases,
        HubSummaryActualCases,
        [Drawer.name]: Drawer,
        "apexchart": VueApexCharts,
    },
    computed: {
        ...mapState(useHubStore,['current_hub', 'current_team'])
    },
    watch: {
        current_team: {
            immediate: true, // Trigger the watcher immediately
            handler(newCurrentTeam) {
                if (newCurrentTeam) {
                    this.hub_id = newCurrentTeam.hub.hub_id;
                    this.hub_team_id = newCurrentTeam.hub_team_id
                    this.revenue_distribution_settings = newCurrentTeam.hub.revenue_distribution_settings
                }
            },
        },
        current_hub: {
            immediate: true,
            handler(newCurrentHub) {
                if (newCurrentHub) {
                    this.revenue_distribution_settings = newCurrentHub.revenue_distribution_settings
                }
            },
        }
    },
    data() {
        return {
            drawerViewHubSummary: false,
            currentTab: 'Pending',
            series: [{
                name: 'Completed',
                type: 'area',
                data: [23000, 11000, 22000, 27000, 13000, 22000, 37000, 21000, 44000, 22000, 30000]
            }, {
                name: 'Pending',
                type: 'area',
                data: [44000, 55000, 41000, 67000, 22000, 43000, 21000, 41000, 56000, 27000, 43000]
            }, {
                name: 'Target Sales',
                type: 'area',
                data: [30000, 25000, 36000, 30000, 45000, 35000, 64000, 52000, 59000, 36000, 39000]
            }],
            chartOptions: {
                chart: {
                    height: 350,
                    type: 'line',
                    stacked: false,
                },
                stroke: {
                    width: [0, 2, 5],
                    curve: 'straight'
                },
                fill: {
                    opacity: [0.5, 0.25, 0.1],
                    gradient: {
                        inverseColors: false,
                        shade: 'light',
                        type: "vertical",
                        opacityFrom: 0.5,
                        opacityTo: 0,
                        stops: [0, 100, 100, 100]
                    }
                },
                labels: ['01/01/2023', '02/01/2023', '03/01/2023', '04/01/2023', '05/01/2023', '06/01/2023', '07/01/2023',
                '08/01/2023', '09/01/2023', '10/01/2023', '11/01/2023'
                ],
                markers: {
                    size: 0
                },
                xaxis: {
                    type: 'datetime'
                },
                yaxis: {
                    min: 0,
                    labels: {
                        formatter: (value) => { 
                            if (value >= 1000) {
                                return (value / 1000).toFixed(0) + 'k';
                            }
                            return value.toLocaleString(undefined, { minimumFractionDigits: 2 });
                         },
                    }
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (y) {
                        if (typeof y !== "undefined") {
                            return 'RM ' + y.toLocaleString(undefined, {minimumFractionDigits: 2});
                        }
                        return y;
                    
                        }
                    }
                }
            },
            hub_id: null,
            hub_team_id: null,
            revenue_distribution_settings: null,
        }
    },
    created() {
        if(this.$route.params.hub_id)
        {
            this.hub_id = this.$route.params.hub_id
        }
    },
    methods: {
        ...mapActions(useHubStore,['getCommsPayoutSummaryList', 'getHubTeams']),
        viewHubSummary() {
            this.drawerViewHubSummary = !this.drawerViewHubSummary;
        },
        selectTab(title) {
            this.currentTab = title
        }
    }
}
</script>